import { render, staticRenderFns } from "./customerAduit.vue?vue&type=template&id=bd62a42e&scoped=true"
import script from "./customerAduit.vue?vue&type=script&lang=js"
export * from "./customerAduit.vue?vue&type=script&lang=js"
import style0 from "./customerAduit.vue?vue&type=style&index=0&id=bd62a42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd62a42e",
  null
  
)

export default component.exports